import React from 'react';
import { useTranslation } from 'react-i18next';

const {
    _class: {
        Common: { Price },
    },
} = Mobi2Go;

const BalanceView = ({ balance, formattedBalanceName }) => {

    const { t } = useTranslation('order.balances');

    const { reference, name, translator_base_key, amount, display_amount, is_monetary } = balance;

    const className = block => `m2g-customer-balances${block || ''}`;

    const display_balance = is_monetary
        ? t('price', {
            price: new Price(amount / 100)
        })
        : t('balance', {
            balance: display_amount
        });

    return (
        <div
            className={className('__balance')}
            id={`customer-balance-${formattedBalanceName}`}
        >
            <div className={className('__amount')}>
                {display_balance}
            </div>
            <div className={className('__title')}>
                {t(`${translator_base_key}_balance_view`, {
                    balance_key: reference[1],
                    balance_name: name
                }) || name}
            </div>
        </div>
    );
};

export default BalanceView;
